var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 703,
    height: 373.092,
    viewBox: "0 0 703 373.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffa03b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.758,0h620.8l82.2,188.918-82.2,184.174h-620.8Z",
    transform: "translate(-340.758)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonOrange);
export default __webpack_public_path__ + "static/media/polygon_orange.188a06e381bdd728eb64e3e8814b6fac.svg";
export { ForwardRef as ReactComponent };